<main class="login">
  <section class="login-card" aria-labelledby="login-title">
    <div class="login-brand">calsium<span></span><small>Cost allocation and Simulation management</small></div>
    <h1 id="login-title" class="login-title">Sign in</h1>
    @if (idleLogout) {
      <p class="login-notice" role="status">You were signed out because of inactivity.</p>
    } @else if (sessionExpired) {
      <p class="login-notice" role="status">Your session has expired. Please sign in again.</p>
    }
    <p class="login-hint">Use your organisation's Scania account.</p>
    <button type="button" class="login-button" (click)="signIn()">
      <svg viewBox="0 0 21 21" width="20" height="20" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      Sign in with Scania Account
    </button>
  </section>
</main>
